export var PLAYBACK_EVENTS;
(function (PLAYBACK_EVENTS) {
    PLAYBACK_EVENTS["PLAYER_CHANGED"] = "playback-events/player-changed";
    PLAYBACK_EVENTS["PLAYLIST_CHANGED"] = "playback-events/playlist-changed";
    PLAYBACK_EVENTS["TRACK_CHANGED"] = "playback-events/track-changed";
    PLAYBACK_EVENTS["STATE_CHANGED"] = "playback-events/state-changed";
})(PLAYBACK_EVENTS || (PLAYBACK_EVENTS = {}));
export var STATE_EVENTS;
(function (STATE_EVENTS) {
    STATE_EVENTS["INIT"] = "playback-state/init";
    STATE_EVENTS["SRC_SET"] = "playback-state/src-set";
    STATE_EVENTS["LOAD_STARTED"] = "playback-state/load-started";
    STATE_EVENTS["METADATA_LOADED"] = "playback-state/metadata-loaded";
    STATE_EVENTS["READY_TO_PLAY"] = "playback-state/ready-to-play";
    STATE_EVENTS["SEEK_IN_PROGRESS"] = "playback-state/seek-in-progress";
    STATE_EVENTS["PLAY_REQUESTED"] = "playback-state/play-requested";
    STATE_EVENTS["WAITING"] = "playback-state/waiting";
    STATE_EVENTS["PLAYING"] = "playback-state/playing";
    STATE_EVENTS["PAUSED"] = "playback-state/paused";
    STATE_EVENTS["ENDED"] = "playback-state/ended";
})(STATE_EVENTS || (STATE_EVENTS = {}));
export var AUDIO_EVENTS;
(function (AUDIO_EVENTS) {
    AUDIO_EVENTS["DURATION_CHANGED"] = "audio-events/duration-changed";
    AUDIO_EVENTS["TIME_UPDATED"] = "audio-events/time-updated";
    AUDIO_EVENTS["BUFFER_UPDATED"] = "audio-events/buffer-updated";
    AUDIO_EVENTS["VOLUME_CHANGED"] = "audio-events/volume-changed";
    AUDIO_EVENTS["MUTE_CHANGED"] = "audio-events/mute-changed";
    AUDIO_EVENTS["RATE_CHANGED"] = "audio-events/rate-changed";
    AUDIO_EVENTS["CAN_PLAY_TROUGH"] = "audio-events/can-play-through";
    AUDIO_EVENTS["ABORT"] = "audio-events/abort";
    AUDIO_EVENTS["ERROR"] = "audio-events/error";
})(AUDIO_EVENTS || (AUDIO_EVENTS = {}));
//# sourceMappingURL=events.js.map